module.exports = __webpack_public_path__ + "022fbc4ae3569edf9e7b91642d9dc880.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/settings_team_2x.png
// module id = 139
// module chunks = 0 1 2 3 4